import type { IconData } from '@stacksjs/iconify-core'

export const treeAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.348 12h7.304l-2.57-4.774L9.54 7.12L7 2.887L4.461 7.12l1.46.104zm7.958-3.003l1.9 3.529a1 1 0 0 1-.88 1.474H8v5a1 1 0 0 1-2 0v-5H1.674a1 1 0 0 1-.88-1.474l1.9-3.529l-.72-.387a1 1 0 0 1-.065-1.124L6.143.429a1 1 0 0 1 1.714 0l4.234 7.057a1 1 0 0 1-.064 1.123z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default treeAlt
